import medicationDSS from './questionnaires/medication-dss';
import clinicalAssessment from './questionnaires/clinical-assessment';

export const initialState = () => ({
  patientId: '',
  version: '',
  bodyWeight: '',
  LDL: '',
  LDLInPreferredUnit: '',
  eGFR: '',
  bloodPressureSystolic: '',
  bloodPressureDiastolic: '',
  pulseRate: '',
  distanceWalked: '',
  perceivedExertion: '',
  isWalkingTestPerformed: null,
  notPerformedReasonGroup: null,
  notPerformedReason: null,
  meanBloodPressureAboveGoal: false,
  currentAmountReceivedHypertensionDrugs: 0,
  ...medicationDSS.reduce((accumulator, currentValue) => ({
    ...accumulator,
    [currentValue.key]: currentValue.defaultValue,
    [currentValue.key + '_V1']: currentValue.defaultValue,
    [currentValue.key + '_V2']: currentValue.defaultValue,
  }), {}),
  ...clinicalAssessment.reduce((accumulator, currentValue) => ({
    ...accumulator,
    [currentValue.key]: currentValue.defaultValue,
    [currentValue.key + '_V1']: currentValue.defaultValue,
    [currentValue.key + '_V2']: currentValue.defaultValue,
  }), {}),
  isValidationMode: false,
});

export default initialState();
